import React from 'react';

/**
 * Wrap a value in a ref that updates automatically
 *
 * Useful to have a stable value referenced in a useEffect
 */
export function useUpdatedRef<T>(value: T): React.MutableRefObject<T> {
    const ref = React.useRef(value);
    React.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref;
}
